const notifications = {
    info: '情報',
    warning: '警告',
    error: 'エラー',
    success: '成功',
  };

export default notifications;
